/**
 * Onboarding logout handler
 *
 * Resets Chatwoot identity, signs out Firebase Auth, and clears the persisted onboarding store.
 */

import { signOut } from 'firebase/auth';
import { auth } from '../../../firebaseConfig';
import { getChatwoot } from '../integrations/chatwoot/chatwootConfig';
import { resetChatwootIdentity } from '../integrations/chatwoot/identifyOnboardingChatwootUser';
import { useOnboardingStore } from './onboardingStore';

/**
 * Signs the user out of onboarding and tears down third-party session state.
 *
 * @return {Promise<void>}
 */
export const handleLogout = async () => {
  const state = useOnboardingStore.getState();
  getChatwoot()?.reset();
  resetChatwootIdentity();
  await signOut(auth);
  state.resetStore();
};
